// Names the marketing box wording a student saw; it is stored on their consent row.
// When the copy of `unified.onboarding.marketingOptIn` changes:
//   1. change the string in packages/i18n/locales/en-US/unified.json
//   2. bump this constant (e.g. 2026-11-v2) and the pinned copy in marketingConsent.spec.ts
//   3. add the new version to consent_wording_versions in laravel/config/marketing.php, keeping the old ones
export const MARKETING_WORDING_VERSION = '2026-09-v1';
